import PropTypes from "prop-types";
import React from "react";
import { Button } from "reactstrap";

/**
 * Button that shows a spinner when loading and is disabled during async.
 */
const LoadingButton = ({
  loading = false,
  children,
  disabled,
  spinnerSize = "sm",
  className = "",
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={disabled || loading}
      className={className}
    >
      {loading && (
        <span
          className={`spinner-border ${spinnerSize ? `spinner-border-${spinnerSize}` : ""} me-1`}
          role="status"
          aria-hidden="true"
        />
      )}
      {children}
    </Button>
  );
};

LoadingButton.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  spinnerSize: PropTypes.oneOf(["sm", ""]),
  className: PropTypes.string,
};

export default LoadingButton;
